import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeletons',
  templateUrl: './skeletons.component.html',
  styleUrls: ['./skeletons.component.css']
})
export class SkeletonsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
